// payment-api.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { setting } from '../../../../setting';
import { UsblickCommonEnum } from 'app/pages/com.usblick.common/usblick-common-enum';

@Injectable({
  providedIn: 'root'
})
export class PaymentApiService {
  private apiUrl = setting.apiBookingUrl;

  constructor(private http: HttpClient) {}

    /**
   * Método compartido para TODAS las pasarelas
   */
  async savePaymetCreditsCards(payload: any): Promise<any> {
    try {
      const response = await fetch(`${this.apiUrl}paymentCreditCards/create`, {
        method: "POST",
        headers: this.getHeaders(),
        credentials: "include",
        body: JSON.stringify(payload)
    });

    const data = await response.json();
      return data;

    } catch (error: any) {
      console.error('❌ Error en savePaymetCreditsCards:', error);
      throw error;
    }
  }

  /**
   * Método compartido para TODAS las pasarelas
   */
  async createPayment(payload: any): Promise<any> {
    try {
      const response = await fetch(`${this.apiUrl}paymentMasters/create`, {
        method: "POST",
        headers: this.getHeaders(),
        credentials: "include",
        body: JSON.stringify(payload)
    });

    const data = await response.json();
      return data;

    } catch (error: any) {
      console.error('❌ Error en createPayment:', error);
      throw error;
    }
  }

  private getHeaders() {
    // La sesión viaja en la cookie HttpOnly auth_token; fetch() no pasa por
    // HttpConfigInterceptor, por eso credentials: "include" se pide acá
    // explícitamente en cada llamada.
    return {
      'Content-Type': 'application/json'
    };
  }
}
